import { render, staticRenderFns } from "./passwordRecover.vue?vue&type=template&id=81d9d80a"
import script from "./passwordRecover.vue?vue&type=script&lang=js"
export * from "./passwordRecover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports